import {useEffect} from 'react';
import tinycolor from 'tinycolor2';

interface UseThemeVariablesProps {
    primaryColor: string;
    isLoading: boolean;
    error?: Error | null;
}

const useThemeVariables = ({
    primaryColor,
    isLoading,
    error
}: UseThemeVariablesProps) => {
    useEffect(() => {
        if (!isLoading && !error) {
            if (tinycolor(primaryColor).isValid()) {
                const rgbColor = tinycolor(primaryColor).toRgb();
                const rgbString = `${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}`;

                const lightColor = tinycolor(primaryColor)
                    .lighten(10)
                    .toHexString();
                const darkColor = tinycolor(primaryColor)
                    .darken(10)
                    .toHexString();

                document.documentElement.style.setProperty(
                    '--primary-color',
                    primaryColor
                );
                document.documentElement.style.setProperty(
                    '--primary-color-rgb',
                    rgbString
                );
                document.documentElement.style.setProperty(
                    '--primary-color-light',
                    lightColor
                );
                document.documentElement.style.setProperty(
                    '--primary-color-dark',
                    darkColor
                );
            } else {
                console.error('Invalid primary color:', primaryColor);
            }
        }
    }, [isLoading, error, primaryColor]);
};

export default useThemeVariables;
